import request from '../../axios';
import {IUserOrderListPayload, IUserOrderListResponse} from './types';

interface IProps {
  pageParam: number;
  payload?: IUserOrderListPayload;
}

export const getUserOrderList = async ({pageParam, payload}: IProps) => {
  // Extract `enabled` from the payload (if it exists) because it's just for the React Query
  const {enabled, ...rest} = payload ?? {};

  const {data}: {data: IUserOrderListResponse} = await request.get(
    `/api/v2/order/list-user-order`,
    {
      params: {
        page: pageParam,
        page_size: payload?.page_size ?? 10,
        ...rest,
      },
    },
  );

  return data;
};
